const $ba30e20475feac5a$export$a9861bd62f48e142 = "nhEAeubCSI57GS2pbE5CzllVrXQ9IRzKwU4wDn2EkWZFqnsk1T";
const $ba30e20475feac5a$export$923ea8233b386e99 = "https://api.tumblr.com/v2/blog/";
const $ba30e20475feac5a$export$b56e23abc93fc286 = 50;


/* ERROR MESSAGES GENERATOR */ const $bd02c871d9c5ba8e$export$493b5823483d2c4e = {
    origin: {
        retrieveBlogBasics: "Sorry, I was unable to get any blog credentials:",
        retrieveBlogPosts: "Sorry, I was unable to get your blog posts:",
        extractPostCredentials: `Sorry, I was unable to find this post's ID:`,
        retrievePostRootID: `Sorry, I was unable to find this post's original ID:`,
        blognameValidation: "Whoops! Unexpected format or spelling:"
    },
    error: {
        notFound: {
            blogname: `I couldn't get any information from the blogname you provided. If you're pretty sure it's spelled correctly, then make sure it's not hidden from people without an account too.`,
            postURL: `I couldn't get any information from the URL you provided.`
        },
        limitExceeded: `Looks like we made too many requests to Tumblr in a short span of time.`,
        notOK: `Something weird happened, either on our own end or yours.`,
        noPostId: `Make sure you entered a valid post URL (E.g.: https://www.tumblr.com/blogname/123456789101112 or https://blogname.tumblr.com/post/123456789101112).`,
        noRootId: `Is the original poster's blog not hidden from people without an account and the post ID correct?`,
        unexpectedError: `Please check if you entered a valid blogname/URL in the appropriate field.`
    },
    ending: {
        generic: `Try again a little later!`,
        specific: `Please either choose another blog to search or try again a little later.`
    }
};
/* ACCOUNTING FOR AS MANY USER INPUT VARIATIONS AND ERRORS AS POSSIBLE */ const $bd02c871d9c5ba8e$var$newFormatStandard = "https://www.tumblr.com/";
const $bd02c871d9c5ba8e$var$newFormatIncomplete = "www.tumblr.com/";
const $bd02c871d9c5ba8e$var$newFormatInformal = "tumblr.com/";
const $bd02c871d9c5ba8e$var$oldFormatStandard = ".tumblr.com/";
const $bd02c871d9c5ba8e$var$oldFormatIncomplete = ".tumblr.com";
function $bd02c871d9c5ba8e$export$1216f43409aa5ee3(input) {
    if (input.startsWith($bd02c871d9c5ba8e$var$newFormatStandard) || input.startsWith($bd02c871d9c5ba8e$var$newFormatIncomplete) || input.startsWith($bd02c871d9c5ba8e$var$newFormatInformal)) return true;
    if (input.endsWith($bd02c871d9c5ba8e$var$oldFormatStandard) || input.endsWith($bd02c871d9c5ba8e$var$oldFormatIncomplete) || input.includes("/post/")) return false;
}
function $bd02c871d9c5ba8e$export$98d83be08b8d417c(input) {
    if ($bd02c871d9c5ba8e$export$1216f43409aa5ee3(input)) return input.trim().replace($bd02c871d9c5ba8e$var$newFormatStandard, "").replace($bd02c871d9c5ba8e$var$newFormatIncomplete, "").replace($bd02c871d9c5ba8e$var$newFormatInformal, "");
    if (!$bd02c871d9c5ba8e$export$1216f43409aa5ee3(input)) return input.trim().replace("https://", "").replace($bd02c871d9c5ba8e$var$oldFormatStandard, " ").replace($bd02c871d9c5ba8e$var$oldFormatIncomplete, " ");
}
function $bd02c871d9c5ba8e$export$ee60134fac004cfe(input) {
    function typoCheck(input) {
        const URLSignifiers = /[.\/:]/g;
        return URLSignifiers.test(input) ? undefined : input;
    }
    if ($bd02c871d9c5ba8e$export$1216f43409aa5ee3(input)) {
        const trimmedInput = $bd02c871d9c5ba8e$export$98d83be08b8d417c(input);
        return typoCheck(trimmedInput);
    }
    if (!$bd02c871d9c5ba8e$export$1216f43409aa5ee3(input)) {
        const trimmedInput = $bd02c871d9c5ba8e$export$98d83be08b8d417c(input).trim();
        return typoCheck(trimmedInput);
    }
    return typoCheck(input);
}
function $bd02c871d9c5ba8e$export$bd8707b01c1d34e9(input) {
    if (!$bd02c871d9c5ba8e$export$ee60134fac004cfe(input)) throw new Error(`${$bd02c871d9c5ba8e$export$493b5823483d2c4e.origin.blognameValidation} ${$bd02c871d9c5ba8e$export$493b5823483d2c4e.error.unexpectedError}`);
    else return $bd02c871d9c5ba8e$export$ee60134fac004cfe(input);
}
function $bd02c871d9c5ba8e$export$968e680ef4be9337(postID, symbol) {
    return postID.slice(-postID.length, postID.indexOf(symbol));
}
function $bd02c871d9c5ba8e$export$3f1985e3ee38d114(type) {
    let storage;
    try {
        storage = window[type];
        const x = "__storage_test__";
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    } catch (error) {
        return e instanceof DOMException && (e.code === 22 || e.code === 1014 || e.name === "QuotaExceededError" || e.name === "NS_ERROR_DOM_QUOTA_REACHED") && storage && storage.length !== 0;
    }
}


const $0f1d4402dffacf5b$export$913815d9607ddcf9 = {
    getBlogname () {
        return JSON.parse(sessionStorage.getItem(`CheckingFor`));
    },
    postRootID: ""
};
async function $0f1d4402dffacf5b$export$abf02488c1c59248(blognameInput) {
    try {
        const blogname = (0, $bd02c871d9c5ba8e$export$bd8707b01c1d34e9)(blognameInput);
        const response = await fetch(`${(0, $ba30e20475feac5a$export$923ea8233b386e99)}${blogname}.tumblr.com/info?api_key=${(0, $ba30e20475feac5a$export$a9861bd62f48e142)}`);
        if (response.status === 404) throw new Error(`${(0, $bd02c871d9c5ba8e$export$493b5823483d2c4e).origin.retrieveBlogBasics} ${(0, $bd02c871d9c5ba8e$export$493b5823483d2c4e).error.notFound.blogname}`);
        if (response.status === 429) throw new Error(`${(0, $bd02c871d9c5ba8e$export$493b5823483d2c4e).origin.retrieveBlogBasics} ${(0, $bd02c871d9c5ba8e$export$493b5823483d2c4e).error.limitExceeded} ${(0, $bd02c871d9c5ba8e$export$493b5823483d2c4e).ending.generic}`);
        if (!response.ok) throw new Error(`${(0, $bd02c871d9c5ba8e$export$493b5823483d2c4e).origin.retrieveBlogBasics} ${(0, $bd02c871d9c5ba8e$export$493b5823483d2c4e).error.notOK} ${(0, $bd02c871d9c5ba8e$export$493b5823483d2c4e).ending.generic}`);
        const infoBasics = await response.json();
        const blogUUID = infoBasics.response.blog.uuid;
        const totalPosts = infoBasics.response.blog.total_posts;
        return [
            blogname,
            blogUUID,
            totalPosts
        ];
    } catch (error) {
        throw error;
    }
}
async function $0f1d4402dffacf5b$export$f093a98644e2e028([blogname, blogUUID, totalPosts]) {
    try {
        const requestPromises = [];
        for(let offset = 0; offset <= totalPosts; offset += (0, $ba30e20475feac5a$export$b56e23abc93fc286))requestPromises.push(await fetch(`${(0, $ba30e20475feac5a$export$923ea8233b386e99)}${blogUUID}/posts?api_key=${(0, $ba30e20475feac5a$export$a9861bd62f48e142)}&limit=${(0, $ba30e20475feac5a$export$b56e23abc93fc286)}&offset=${offset}&reblog_info=true`));
        const requestStatus = requestPromises.map((request)=>request.status);
        if (requestStatus.includes(404)) throw new Error(`${(0, $bd02c871d9c5ba8e$export$493b5823483d2c4e).origin.retrieveBlogPosts} ${(0, $bd02c871d9c5ba8e$export$493b5823483d2c4e).error.notFound.blogname} ${(0, $bd02c871d9c5ba8e$export$493b5823483d2c4e).ending.specific}`);
        if (requestStatus.includes(429)) throw new Error(`${(0, $bd02c871d9c5ba8e$export$493b5823483d2c4e).origin.retrieveBlogPosts} ${(0, $bd02c871d9c5ba8e$export$493b5823483d2c4e).error.limitExceeded} ${(0, $bd02c871d9c5ba8e$export$493b5823483d2c4e).ending.specific}`);
        if (!requestStatus.every((status)=>status === 200)) throw new Error(`${(0, $bd02c871d9c5ba8e$export$493b5823483d2c4e).origin.retrieveBlogPosts} ${(0, $bd02c871d9c5ba8e$export$493b5823483d2c4e).error.notOK} ${(0, $bd02c871d9c5ba8e$export$493b5823483d2c4e).ending.specific}`);
        const response = await Promise.all(requestPromises.map(async (response)=>await response.json()));
        const postsInfo = response.flatMap((request)=>{
            return request.response.posts.map((post)=>{
                return {
                    rootID: post.reblogged_root_id ?? post.id_string,
                    postURL: post.post_url
                };
            });
        });
        if (!(0, $bd02c871d9c5ba8e$export$3f1985e3ee38d114)("sessionStorage")) throw new Error(`Sorry! Seems like you don't have enough space in your session storage or it isn't altogether available in the browser you're using. Reblog Checker needs access to it in order to work.`);
        sessionStorage.setItem(`CheckingFor`, JSON.stringify(`${blogname}`));
        sessionStorage.setItem(`${blogname}PostsInfo`, JSON.stringify(postsInfo));
        console.log(`${blogname}'s posts root IDs and reblogs URLs retrieved and stored in ${blogname}PostsInfo!`);
    } catch (error) {
        throw error;
    }
}
async function $0f1d4402dffacf5b$export$b4cd066a67fd4e9f(URL) {
    try {
        /* NEW URL FORMAT */ if ((0, $bd02c871d9c5ba8e$export$1216f43409aa5ee3)(URL)) {
            const URLToTreat = (0, $bd02c871d9c5ba8e$export$98d83be08b8d417c)(URL).replace("/", " ").split(" ");
            const [blogname, postID] = URLToTreat;
            /* INVALID POST URL ERROR TAKES PRECEDENCE OVER BLOG UUID NOT FOUND */ if (!postID) throw new Error(`${(0, $bd02c871d9c5ba8e$export$493b5823483d2c4e).origin.extractPostCredentials} ${(0, $bd02c871d9c5ba8e$export$493b5823483d2c4e).error.notFound.postURL} ${(0, $bd02c871d9c5ba8e$export$493b5823483d2c4e).error.noPostId}`);
            const [, blogUUID] = await $0f1d4402dffacf5b$export$abf02488c1c59248(blogname);
            if (!blogUUID) return;
            if (postID.includes("/")) {
                const postIDClean = (0, $bd02c871d9c5ba8e$export$968e680ef4be9337)(postID, "/");
                return [
                    blogname,
                    blogUUID,
                    postIDClean
                ];
            }
            if (postID.includes("?")) {
                const postIDClean = (0, $bd02c871d9c5ba8e$export$968e680ef4be9337)(postID, "?");
                return [
                    blogname,
                    blogUUID,
                    postIDClean
                ];
            }
            return [
                blogname,
                blogUUID,
                postID
            ];
        }
        /* OLD URL FORMAT */ if (!(0, $bd02c871d9c5ba8e$export$1216f43409aa5ee3)(URL)) {
            const URLToTreat = (0, $bd02c871d9c5ba8e$export$98d83be08b8d417c)(URL).replace("post/", "").split(" ");
            const [blogname, postID] = URLToTreat;
            /* INVALID POST URL ERROR TAKES PRECEDENCE OVER BLOG UUID NOT FOUND */ if (!postID) throw new Error(`${(0, $bd02c871d9c5ba8e$export$493b5823483d2c4e).origin.extractPostCredentials} ${(0, $bd02c871d9c5ba8e$export$493b5823483d2c4e).error.notFound.postURL} ${(0, $bd02c871d9c5ba8e$export$493b5823483d2c4e).error.noPostId}`);
            const [, blogUUID] = await $0f1d4402dffacf5b$export$abf02488c1c59248(blogname);
            if (!blogUUID) return;
            if (postID.includes("/")) {
                const postIDClean = (0, $bd02c871d9c5ba8e$export$968e680ef4be9337)(postID, "/");
                return [
                    blogname,
                    blogUUID,
                    postIDClean
                ];
            }
            if (postID.includes("?")) {
                const postIDClean = (0, $bd02c871d9c5ba8e$export$968e680ef4be9337)(postID, "?");
                return [
                    blogname,
                    blogUUID,
                    postIDClean
                ];
            }
            return [
                blogname,
                blogUUID,
                postID
            ];
        }
        return;
    } catch (error) {
        throw error;
    }
}
async function $0f1d4402dffacf5b$export$b890cb1c1145887b([, blogUUID, postID]) {
    try {
        const response = await fetch(`${(0, $ba30e20475feac5a$export$923ea8233b386e99)}${blogUUID}/posts?api_key=${(0, $ba30e20475feac5a$export$a9861bd62f48e142)}&id=${postID}&reblog_info=true`);
        if (response.status === 404) throw new Error(`${(0, $bd02c871d9c5ba8e$export$493b5823483d2c4e).origin.retrievePostRootID} ${(0, $bd02c871d9c5ba8e$export$493b5823483d2c4e).error.notFound.postURL} ${(0, $bd02c871d9c5ba8e$export$493b5823483d2c4e).error.noRootId}`);
        if (response.status === 429) throw new Error(`${(0, $bd02c871d9c5ba8e$export$493b5823483d2c4e).origin.retrievePostRootID} ${(0, $bd02c871d9c5ba8e$export$493b5823483d2c4e).error.limitExceeded} ${(0, $bd02c871d9c5ba8e$export$493b5823483d2c4e).ending.generic}`);
        if (!response.ok) throw new Error(`${(0, $bd02c871d9c5ba8e$export$493b5823483d2c4e).origin.retrievePostRootID} ${(0, $bd02c871d9c5ba8e$export$493b5823483d2c4e).error.notOK} ${(0, $bd02c871d9c5ba8e$export$493b5823483d2c4e).ending.generic}`);
        const postInfo = await response.json();
        const rootID = postInfo.response.posts.at(0).reblogged_root_id ?? postInfo.response.posts.at(0).id_string;
        return rootID;
    } catch (error) {
        throw error;
    }
}
function $0f1d4402dffacf5b$export$f377efffa0e0722b(blogname, postRootID) {
    const postsInfo = JSON.parse(sessionStorage.getItem(`${blogname}PostsInfo`));
    if (!postsInfo) return;
    const targetedPosts = postsInfo.filter((post)=>post.rootID === postRootID);
    const numberOfInstances = targetedPosts.length;
    if (numberOfInstances) {
        const instancesURLs = targetedPosts.map((instance)=>instance.postURL);
        return [
            numberOfInstances,
            instancesURLs
        ];
    } else return;
}


class $3a07c34e115c11c9$export$2e2bcd8739ae039 {
    inputSet = [
        ".input",
        "input"
    ];
    errorMessage = '.message[data-type="error"]';
    mainScreen = document.querySelector("main");
    stepHeading = document.querySelector(".step-heading");
    iconHeading = document.querySelector(".icon-heading");
    checkingForWindow = document.querySelector(".checking-for");
    buttonTag = document.querySelector(".button-tag");
    addHandlerScreenReset(activeScreen = this.activeScreen) {
        activeScreen.querySelector("input").addEventListener("input", this.resetScreen.bind(this));
    }
    stepScreenInit(activeStep = this.activeStep) {
        [
            this.mainScreen,
            this.stepHeading,
            this.checkingForWindow
        ].forEach((element)=>element.setAttribute("data-state", activeStep));
    }
    loadStopAnimation() {
        const loadingSpinnerAnimation = this.stepHeading.getAnimations({
            subtree: true
        }).find((animation)=>animation.animationName === "loadingSpinner");
        loadingSpinnerAnimation.pause();
        const currentFrame = getComputedStyle(this.stepHeading).transform;
        const loadingStopAnimation = this.stepHeading.animate([
            {
                transform: currentFrame
            },
            {
                transform: "matrix(1, 0, 0, 1, 0, 0)"
            }
        ], {
            duration: 300,
            fill: "forwards"
        });
        return loadingStopAnimation.finished;
    }
    renderSpinner() {
        this.stepHeading.setAttribute("data-state", "loading-spinner");
    }
    inputValidation(entryValidity, activeScreen = this.activeScreen) {
        this.inputSet.forEach((element)=>activeScreen.querySelector(element).setAttribute("data-valid", entryValidity));
        if (!entryValidity) activeScreen.querySelector("button").setAttribute("disabled", true);
    }
    renderError(activeScreen, error) {
        const activeErrorMessage = activeScreen.querySelector(this.errorMessage);
        activeErrorMessage.setAttribute("data-active", true);
        activeErrorMessage.querySelector("p").innerText = `${error.message}`;
    }
    errorManager(error, activeScreen = this.activeScreen) {
        this.loadStopAnimation().then(()=>{
            this.renderError(activeScreen, error);
            this.stepScreenInit();
            this.inputValidation(false);
        });
    }
    resetForm() {
        this.stepForm[1].localName !== "button" ? this.stepForm.forEach((form)=>form.reset()) : this.stepForm.reset();
    }
    resetScreen(resetEverything = true) {
        const resettableAttributes = [
            "data-active",
            "data-valid",
            "disabled"
        ];
        if (!resetEverything) resettableAttributes.shift();
        resettableAttributes.forEach((attribute)=>this.mainScreen.querySelectorAll(`[${attribute}]`).forEach((activeElement)=>activeElement.removeAttribute(attribute)));
    }
}


class $00699351e50f4618$var$StepOneView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    activeStep = "step-one";
    activeScreen = document.querySelector("#step-one");
    stepForm = document.querySelector(".blogname-form");
    constructor(){
        super();
        this.addHandlerScreenReset();
    }
    addHandlerBlognameForm(handler) {
        this.stepForm.addEventListener("submit", (event)=>{
            event.preventDefault();
            const formData = new FormData(event.target);
            const blognameInput = Object.fromEntries(formData).blognameForm;
            handler(blognameInput);
        });
    }
}
var $00699351e50f4618$export$2e2bcd8739ae039 = new $00699351e50f4618$var$StepOneView();



class $66f82ae3c80aad68$var$StepTwoView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    activeStep = "step-two";
    activeScreen = document.querySelector("#step-two");
    stepForm = document.querySelector(".post-form");
    constructor(){
        super();
        this.addHandlerScreenReset();
    }
    addHandlerPostForm(handler) {
        this.stepForm.addEventListener("submit", (event)=>{
            this.resetScreen();
            event.preventDefault();
            const formData = new FormData(event.target);
            const postInput = Object.fromEntries(formData).postForm;
            handler(postInput);
        });
    }
    setCheckingForBlogname(blogname) {
        this.buttonTag.innerText = blogname;
    }
}
var $66f82ae3c80aad68$export$2e2bcd8739ae039 = new $66f82ae3c80aad68$var$StepTwoView();



class $dd6c020ea341222a$var$SessionView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    stepForm = document.querySelectorAll("form");
    scrollIntoView = document.querySelector("header button");
    constructor(){
        super();
        this.addHandlerScrollIntoView();
    }
    addHandlerScrollIntoView() {
        this.scrollIntoView.addEventListener("click", ()=>this.mainScreen.scrollIntoView({
                behavior: "smooth"
            }));
    }
    addHandlerSessionWatch(handler) {
        window.addEventListener("load", handler);
    }
    addHandlerStepWatch(handler) {
        const observer = new MutationObserver(handler);
        observer.observe(this.mainScreen, {
            attributeFilter: [
                "data-state"
            ],
            attributeOldValue: true
        });
    }
    addHandlerStoreScroll(handler) {
        document.addEventListener("scroll", handler, {
            passive: true
        });
    }
    addHandlerStepBackward(handler) {
        this.buttonTag.addEventListener("click", handler);
    }
    stepWatch(mutationList) {
        const stepIcons = [
            "bi-1-circle",
            "bi-2-circle"
        ];
        mutationList.forEach((mutation)=>{
            if (mutation.target.dataset.state !== mutation.oldValue) stepIcons.forEach((stepIcon)=>this.iconHeading.classList.toggle(stepIcon));
        });
    }
    debounce(someFunction) {
        let frame;
        return (...parameters)=>{
            if (frame) cancelAnimationFrame(frame);
            frame = requestAnimationFrame(()=>{
                someFunction(...parameters);
            });
        };
    }
    storeScroll() {
        const elements = [
            this.stepHeading,
            this.checkingForWindow
        ];
        document.documentElement.dataset.scroll = window.scrollY;
        if (window.scrollY >= window.innerHeight - window.innerHeight / 3) elements.forEach((element)=>element.setAttribute("data-visible", true));
        else elements.forEach((element)=>element.setAttribute("data-visible", false));
    }
}
var $dd6c020ea341222a$export$2e2bcd8739ae039 = new $dd6c020ea341222a$var$SessionView();



class $ebc1934d4b1e594a$var$OutputView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    outputWindow = document.querySelectorAll(".output");
    numberOfInstances = document.querySelector(".instances");
    postURLs = document.querySelector(".post-urls");
    setReblogInstances(numberOfInstances) {
        this.numberOfInstances.innerText = numberOfInstances > 1 ? `${numberOfInstances} times` : `${numberOfInstances} time`;
    }
    setURLAttributes(element, attributes) {
        Object.keys(attributes).forEach((attribute)=>{
            element.setAttribute(attribute, attributes[attribute]);
        });
    }
    setReblogURLs(instancesURLs) {
        instancesURLs.forEach((URL)=>{
            const hrefAttributes = {
                href: URL,
                target: "_blank",
                rel: "noopener noreferrer"
            };
            const aHref = document.createElement("a");
            aHref.innerText = URL;
            this.setURLAttributes(aHref, hrefAttributes);
            this.postURLs.appendChild(aHref);
        });
    }
    resetReblogURLs() {
        if (this.postURLs.hasChildNodes()) this.postURLs.querySelectorAll("a").forEach((element)=>this.postURLs.removeChild(element));
    }
    showResult(outcome) {
        this.outputWindow.forEach((output)=>output.dataset.result === outcome && output.setAttribute("data-active", true));
    }
}
var $ebc1934d4b1e594a$export$2e2bcd8739ae039 = new $ebc1934d4b1e594a$var$OutputView();


function $f50bd1f2915ed0f2$var$controlSessionWatch() {
    if (!sessionStorage.getItem(`CheckingFor`)) (0, $00699351e50f4618$export$2e2bcd8739ae039).stepScreenInit();
    else {
        (0, $66f82ae3c80aad68$export$2e2bcd8739ae039).stepScreenInit();
        (0, $66f82ae3c80aad68$export$2e2bcd8739ae039).setCheckingForBlogname($0f1d4402dffacf5b$export$913815d9607ddcf9.getBlogname());
    }
}
function $f50bd1f2915ed0f2$var$controlStepWatch(mutationList) {
    (0, $dd6c020ea341222a$export$2e2bcd8739ae039).stepWatch(mutationList);
}
function $f50bd1f2915ed0f2$var$controlStoreScroll() {
    (0, $dd6c020ea341222a$export$2e2bcd8739ae039).debounce((0, $dd6c020ea341222a$export$2e2bcd8739ae039).storeScroll);
    (0, $dd6c020ea341222a$export$2e2bcd8739ae039).storeScroll();
}
async function $f50bd1f2915ed0f2$var$controlBlognameForm(blognameInput) {
    try {
        (0, $dd6c020ea341222a$export$2e2bcd8739ae039).renderSpinner();
        const blogBasics = await $0f1d4402dffacf5b$export$abf02488c1c59248(blognameInput);
        (0, $00699351e50f4618$export$2e2bcd8739ae039).inputValidation(true);
        await $0f1d4402dffacf5b$export$f093a98644e2e028(blogBasics);
        (0, $dd6c020ea341222a$export$2e2bcd8739ae039).loadStopAnimation().then(()=>{
            (0, $00699351e50f4618$export$2e2bcd8739ae039).resetScreen(false);
            (0, $66f82ae3c80aad68$export$2e2bcd8739ae039).stepScreenInit();
            (0, $66f82ae3c80aad68$export$2e2bcd8739ae039).setCheckingForBlogname($0f1d4402dffacf5b$export$913815d9607ddcf9.getBlogname());
        });
    } catch (error) {
        console.error(error);
        (0, $00699351e50f4618$export$2e2bcd8739ae039).errorManager(error);
    }
}
async function $f50bd1f2915ed0f2$var$controlPostForm(postInput) {
    try {
        (0, $dd6c020ea341222a$export$2e2bcd8739ae039).renderSpinner();
        const postCredentials = await $0f1d4402dffacf5b$export$b4cd066a67fd4e9f(postInput);
        const postRootID = await $0f1d4402dffacf5b$export$b890cb1c1145887b(postCredentials);
        (0, $66f82ae3c80aad68$export$2e2bcd8739ae039).inputValidation(true);
        $0f1d4402dffacf5b$export$913815d9607ddcf9.postRootID = postRootID;
        (0, $dd6c020ea341222a$export$2e2bcd8739ae039).loadStopAnimation().then(()=>{
            (0, $66f82ae3c80aad68$export$2e2bcd8739ae039).resetScreen(false);
            (0, $66f82ae3c80aad68$export$2e2bcd8739ae039).stepScreenInit();
            $f50bd1f2915ed0f2$var$controlCheckResult();
        });
    } catch (error) {
        console.error(error);
        (0, $66f82ae3c80aad68$export$2e2bcd8739ae039).errorManager(error);
    }
}
function $f50bd1f2915ed0f2$var$controlCheckResult() {
    const reblogCheckData = $0f1d4402dffacf5b$export$f377efffa0e0722b($0f1d4402dffacf5b$export$913815d9607ddcf9.getBlogname(), $0f1d4402dffacf5b$export$913815d9607ddcf9.postRootID);
    if (!reblogCheckData) {
        (0, $ebc1934d4b1e594a$export$2e2bcd8739ae039).showResult("negative");
        return;
    }
    const [numberOfInstances, instancesURLs] = reblogCheckData;
    (0, $ebc1934d4b1e594a$export$2e2bcd8739ae039).setReblogInstances(numberOfInstances);
    (0, $ebc1934d4b1e594a$export$2e2bcd8739ae039).resetReblogURLs();
    (0, $ebc1934d4b1e594a$export$2e2bcd8739ae039).setReblogURLs(instancesURLs);
    (0, $ebc1934d4b1e594a$export$2e2bcd8739ae039).showResult("positive");
}
function $f50bd1f2915ed0f2$var$controlStepBackward() {
    if (window.confirm(`Done checking for ${$0f1d4402dffacf5b$export$913815d9607ddcf9.getBlogname()}? This will take you back to the previous step.`)) {
        sessionStorage.clear();
        (0, $dd6c020ea341222a$export$2e2bcd8739ae039).resetForm();
        (0, $dd6c020ea341222a$export$2e2bcd8739ae039).resetScreen();
        (0, $00699351e50f4618$export$2e2bcd8739ae039).stepScreenInit();
    }
}
function $f50bd1f2915ed0f2$var$init() {
    (0, $dd6c020ea341222a$export$2e2bcd8739ae039).addHandlerSessionWatch($f50bd1f2915ed0f2$var$controlSessionWatch);
    (0, $dd6c020ea341222a$export$2e2bcd8739ae039).addHandlerStepWatch($f50bd1f2915ed0f2$var$controlStepWatch);
    (0, $dd6c020ea341222a$export$2e2bcd8739ae039).addHandlerStoreScroll($f50bd1f2915ed0f2$var$controlStoreScroll);
    (0, $dd6c020ea341222a$export$2e2bcd8739ae039).addHandlerStepBackward($f50bd1f2915ed0f2$var$controlStepBackward);
    (0, $00699351e50f4618$export$2e2bcd8739ae039).addHandlerBlognameForm($f50bd1f2915ed0f2$var$controlBlognameForm);
    (0, $66f82ae3c80aad68$export$2e2bcd8739ae039).addHandlerPostForm($f50bd1f2915ed0f2$var$controlPostForm);
}
$f50bd1f2915ed0f2$var$init();


//# sourceMappingURL=index.5ee3ca99.js.map
